import React, { useState, useEffect, useRef } from 'react'
import { useFloatMessage } from './../../Providers/FloatMessage'
import { SecondaryBase } from './../Commons/SecondaryBase'
import { Soccer as SoccerOverlay } from './../../Overlays/Overlays/Soccer'
import { Dance as DanceOverlay } from './../../Overlays/Overlays/Dance'
import { Bongo as BongoOverlay } from './../../Overlays/Overlays/Bongo'
import { Kiss as KissOverlay } from './../../Overlays/Overlays/Kiss'
import { Lineup as LineupAdmin } from './Lineup'
import { Score as ScoreAdmin } from './Score'
import { Lineup as LineupOverlay } from './../../Overlays/Overlays/Lineup'
import { Score as ScoreOverlay } from './../../Overlays/Overlays/Score'
import { GetSoccerConfig, SetSoccerConfig, ShowSoccerOverlay, HideSoccerOverlay } from './../../../utilities/BL/Soccer'
import { TriggerPresentation } from './../../../utilities/BL/Lineup'
import { TriggerScoreNotification, UpdateScoreStyle, GetScoreState } from './../../../utilities/BL/Score'
import { 
    GetDanceConfig, 
    SetDanceConfig, 
    ShowDanceOverlay, 
    HideDanceOverlay, 
    TriggerExplosion, 
    ToggleFiestaMode, 
    TriggerDancers 
} from './../../../utilities/BL/Dance'
import {
    GetBongoConfig,
    SetBongoConfig,
    ShowBongoOverlay,
    HideBongoOverlay,
    TriggerBongoHit,
    TriggerBongoMode
} from './../../../utilities/BL/Bongo'
import {
    GetKissConfig,
    SetKissConfig,
    ShowKissOverlay,
    HideKissOverlay,
    TriggerKissAction
} from './../../../utilities/BL/Kiss'

/**
 * COMPONENTE: PANEL DE CONTROL DE FÚTBOL (ADMIN ACORDEÓN UNIFICADO)
 * ------------------------------------------------------------------
 * Organizado en 4 secciones colapsables principales de manera vertical.
 * Incluye estados "AL AIRE" / "OCULTO", textos de sliders claros y de
 * alto contraste, y retroalimentación directa en la vista previa.
 * ------------------------------------------------------------------
 */
const Soccer = ({ getOutOfTheDynamic }) => {
    const { showMessage } = useFloatMessage();
    const [isLoading, setIsLoading] = useState(false);
    const [activePreview, setActivePreview] = useState('soccer'); // 'soccer', 'dance', 'bongo', 'kiss'

    // Refs
    const logoInputRef = useRef(null);
    const kissLogoInputRef = useRef(null);

    // --- ACCORDIONES PRINCIPALES (VERTICALES) ---
    const [isSoccerMainExpanded, setIsSoccerMainExpanded] = useState(true);
    const [isDanceMainExpanded, setIsDanceMainExpanded] = useState(false);
    const [isBongoMainExpanded, setIsBongoMainExpanded] = useState(false);
    const [isKissMainExpanded, setIsKissMainExpanded] = useState(false);
    const [isLineupMainExpanded, setIsLineupMainExpanded] = useState(false);
    const [isScoreMainExpanded, setIsScoreMainExpanded] = useState(false);

    // --- VISIBILIDAD DE OVERLAYS DE LINEUP Y SCORE ---
    const [isLineupVisible, setIsLineupVisible] = useState(false);
    const [isScoreVisible, setIsScoreVisible] = useState(false);

    // --- SUB-SECCIONES COLAPSABLES ---
    const [isTextExpanded, setIsTextExpanded] = useState(true);
    const [isStyleExpanded, setIsStyleExpanded] = useState(false);
    const [isLayoutExpanded, setIsLayoutExpanded] = useState(false);
    const [isLogoExpanded, setIsLogoExpanded] = useState(false);

    const [isDanceTextExpanded, setIsDanceTextExpanded] = useState(true);
    const [isDanceStyleExpanded, setIsDanceStyleExpanded] = useState(false);
    const [isDanceShapesExpanded, setIsDanceShapesExpanded] = useState(false);

    const [isBongoStyleExpanded, setIsBongoStyleExpanded] = useState(true);
    const [isBongoDecoExpanded, setIsBongoDecoExpanded] = useState(false);
    const [isBongoLayoutExpanded, setIsBongoLayoutExpanded] = useState(false);

    const [isKissTextExpanded, setIsKissTextExpanded] = useState(true);
    const [isKissStyleExpanded, setIsKissStyleExpanded] = useState(false);
    const [isKissShapesExpanded, setIsKissShapesExpanded] = useState(false);
    const [isKissLayoutExpanded, setIsKissLayoutExpanded] = useState(false);
    const [isKissSpeedExpanded, setIsKissSpeedExpanded] = useState(false);

    const [isTensionActive, setIsTensionActive] = useState(false);
    const [isHeartTensionActive, setIsHeartTensionActive] = useState(false);
    const [isSuccessActive, setIsSuccessActive] = useState(false);
    const [isFailActive, setIsFailActive] = useState(false);
    const [isDestelloActive, setIsDestelloActive] = useState(false);

    const [isDanceFiestaActive, setIsDanceFiestaActive] = useState(false);
    const [isNormalDancersActive, setIsNormalDancersActive] = useState(false);
    const [isFastDancersActive, setIsFastDancersActive] = useState(false);

    // --- ESTADOS DE CONFIGURACIÓN ---
    const [config, setConfig] = useState({
        titleText: 'ASISTENCIA TOTAL',
        numberText: '333',
        thanksText: '¡GRACIAS!',
        visible: true,
        animationEffect: 'cinematic-blur',
        enableAnimation: true,
        titleColor: '#ffffff',
        numberGradientStart: '#ffffff',
        numberGradientMiddle: '#d4af37',
        numberGradientEnd: '#8a631b',
        thanksColor: '#f9e596',
        particlesColor: '#d4af37',
        glowColor: '#d4af37',
        backgroundGradientStart: '#151520',
        backgroundGradientEnd: '#030305',
        scale: 1.0,
        titleSize: 0.9,
        numberSize: 14.0,
        thanksSize: 2.2,
        offsetX: 0,
        offsetY: -120,
        logoDataUrl: null,
        logoScale: 1.0,
        logoOffsetX: 0,
        logoOffsetY: 0,
        showLogoSweep: true
    });

    const [danceConfig, setDanceConfig] = useState({
        titleText: 'BÁILELE',
        visible: true,
        frameStyle: 'neon-classic',
        eqEffect: 'suave',
        eqGradientStart: '#00ffff',
        eqGradientEnd: '#ff00ff',
        eqGlow: 20,
        floatingShape: 'notes-stars',
        shapeColor: '#00ffff',
        shapeGlow: 15,
        shapeOpacity: 0.3,
        shapeBorderWidth: 2,
        enableDancers: true,
        fogColor: '#250022',
        fogSpeed: 4.0,
        bpm: 120,
        scale: 1.0,
        titleSize: 8.0,
        offsetX: 0,
        offsetY: 0,
        frameZoom: 94
    });

    const [bongoConfig, setBongoConfig] = useState({
        enabled: true,
        visible: true,
        bongoSkin: 'classic-wood',
        hitEffect: 'shockwave',
        hitColor: '#00ffff',
        bgPreset: 'tropical-sunset',
        decoStyle: 'beach-tropical',
        floatingShape: 'fireflies',
        shapeOpacity: 0.3,
        shapeGlow: 15,
        scale: 1.0,
        offsetX: 0,
        offsetY: 0,
        bpm: 140,
        audioReact: false
    });

    const [kissConfig, setKissConfig] = useState({
        visible: true,
        titleText: 'KISS CAM',
        failText: '¡BUUUUU!',
        frameStyle: 'classic-red',
        frameColor: '#ff0033',
        borderWidth: 6,
        frameZoom: 92,
        lowerThirdBgColor: '#000000',
        lowerThirdBgOpacity: 0.6,
        screenFilter: 'none',
        floatingShape: 'hearts',
        shapeOpacity: 0.3,
        shapeGlow: 15,
        logoDataUrl: null,
        logoCorner: 'top-left',
        logoScale: 1.0,
        scale: 1.0,
        titleSize: 3.5,
        offsetX: 0,
        offsetY: 0,
        successSpeed: 1.6,
        failSpeed: 1.6,
        destelloSpeed: 1.6
    });

    // Cargar configuraciones iniciales
    useEffect(() => {
        const loadAllConfigs = async () => {
            setIsLoading(true);
            const resSoccer = await GetSoccerConfig();
            if (resSoccer.success && resSoccer.data) {
                setConfig({ ...resSoccer.data });
            }
            const resDance = await GetDanceConfig();
            if (resDance.success && resDance.data) {
                setDanceConfig({ ...resDance.data });
            }
            const resBongo = await GetBongoConfig();
            if (resBongo.success && resBongo.data) {
                setBongoConfig({ ...resBongo.data });
            }
            const resKiss = await GetKissConfig();
            if (resKiss.success && resKiss.data) {
                setKissConfig({ ...resKiss.data });
            }
            const resScore = await GetScoreState();
            if (resScore.success && resScore.data) {
                setIsScoreVisible(resScore.data.isVisible);
            }
            setIsLoading(false);
        };
        loadAllConfigs();
    }, []);

    const returnToDashboard = () => {
        try {
            getOutOfTheDynamic();
        } catch {
            window.location.href = '/admin/dashboard';
        }
    };

    // --- HANDLERS ASISTENCIA ---
    const saveSoccerSettings = async () => {
        setIsLoading(true);
        const res = await SetSoccerConfig(config);
        setIsLoading(false);
        if (res.success) showMessage('Marcador de Asistencia guardado.', 'success');
    };

    const toggleSoccerVisibility = async (shouldShow) => {
        setIsLoading(true);
        const res = shouldShow ? await ShowSoccerOverlay() : await HideSoccerOverlay();
        setIsLoading(false);
        if (res.success) {
            setConfig(prev => ({ ...prev, visible: shouldShow }));
            showMessage(shouldShow ? 'Marcador de Asistencia enviado al aire.' : 'Marcador de Asistencia ocultado de la transmisión.', 'info');
        }
    };

    // --- HANDLERS DANCE CAM ---
    const saveDanceSettings = async () => {
        setIsLoading(true);
        const res = await SetDanceConfig(danceConfig);
        setIsLoading(false);
        if (res.success) showMessage('Ajustes de Dance Cam guardados.', 'success');
    };

    const toggleDanceVisibility = async (shouldShow) => {
        setIsLoading(true);
        const res = shouldShow ? await ShowDanceOverlay() : await HideDanceOverlay();
        setIsLoading(false);
        if (res.success) {
            setDanceConfig(prev => ({ ...prev, visible: shouldShow }));
            showMessage(shouldShow ? 'Dance Cam enviada al aire.' : 'Dance Cam ocultada de la transmisión.', 'info');
        }
    };

    const triggerExplosionAction = async () => {
        await TriggerExplosion();
        showMessage('¡Destello de notas y estrellas detonado!', 'success');
    };

    const toggleDanceFiestaAction = async (state) => {
        await ToggleFiestaMode(state);
        setIsDanceFiestaActive(state);
        showMessage(state ? 'Drop / Modo Fiesta Activado!' : 'Modo Fiesta Desactivado.', 'info');
    };

    const triggerDancersAction = async (isFast, state = false) => {
        await TriggerDancers(isFast, state);
        if (isFast) {
            setIsFastDancersActive(state);
            if (state) setIsNormalDancersActive(false);
        } else {
            setIsNormalDancersActive(state);
            if (state) setIsFastDancersActive(false);
        }
        showMessage(state 
            ? (isFast ? 'Bailarines rápidos mostrados.' : 'Bailarines normales mostrados.')
            : (isFast ? 'Bailarines rápidos ocultados.' : 'Bailarines normales ocultados.'), 'info');
    };

    // --- HANDLERS BONGO CAM ---
    const saveBongoSettings = async () => {
        setIsLoading(true);
        const res = await SetBongoConfig(bongoConfig);
        setIsLoading(false);
        if (res.success) showMessage('Ajustes de Bongo Cam guardados.', 'success');
    };

    const toggleBongoVisibility = async (shouldShow) => {
        setIsLoading(true);
        const res = shouldShow ? await ShowBongoOverlay() : await HideBongoOverlay();
        setIsLoading(false);
        if (res.success) {
            setBongoConfig(prev => ({ ...prev, visible: shouldShow }));
            showMessage(shouldShow ? 'Bongo Cam enviado al aire.' : 'Bongo Cam ocultado de la transmisión.', 'info');
        }
    };

    // --- HANDLERS KISS CAM ---
    const saveKissSettings = async () => {
        setIsLoading(true);
        const res = await SetKissConfig(kissConfig);
        setIsLoading(false);
        if (res.success) showMessage('Ajustes de Kiss Cam guardados.', 'success');
    };

    const toggleKissVisibility = async (shouldShow) => {
        setIsLoading(true);
        const res = shouldShow ? await ShowKissOverlay() : await HideKissOverlay();
        setIsLoading(false);
        if (res.success) {
            setKissConfig(prev => ({ ...prev, visible: shouldShow }));
            showMessage(shouldShow ? 'Kiss Cam enviada al aire.' : 'Kiss Cam ocultada de la transmisión.', 'info');
        }
    };

    const triggerKissLiveAction = async (actionName, state = false) => {
        await TriggerKissAction(actionName, state);
        if (actionName === 'success') {
            setIsSuccessActive(state);
            if (state) {
                setIsFailActive(false);
                setIsDestelloActive(false);
                setIsTensionActive(false);
                setIsHeartTensionActive(false);
            }
            showMessage(state ? 'Beso (Éxito) mostrado.' : 'Beso ocultado.', 'success');
        }
        else if (actionName === 'fail') {
            setIsFailActive(state);
            if (state) {
                setIsSuccessActive(false);
                setIsDestelloActive(false);
                setIsTensionActive(false);
                setIsHeartTensionActive(false);
            }
            showMessage(state ? 'Fracaso (Boo) mostrado.' : 'Fracaso ocultado.', 'warning');
        }
        else if (actionName === 'destello') {
            setIsDestelloActive(state);
            if (state) {
                setIsSuccessActive(false);
                setIsFailActive(false);
                setIsTensionActive(false);
                setIsHeartTensionActive(false);
            }
            showMessage(state ? 'Destello de Corazones mostrado.' : 'Destello ocultado.', 'info');
        }
        else if (actionName === 'tension') {
            setIsTensionActive(state);
            if (state) {
                setIsSuccessActive(false);
                setIsFailActive(false);
                setIsDestelloActive(false);
                setIsHeartTensionActive(false);
            }
            showMessage(state ? 'Tensión Clásica ON' : 'Tensión OFF', 'info');
        }
        else if (actionName === 'hearttension') {
            setIsHeartTensionActive(state);
            if (state) {
                setIsSuccessActive(false);
                setIsFailActive(false);
                setIsDestelloActive(false);
                setIsTensionActive(false);
            }
            showMessage(state ? 'Visor Corazón ON' : 'Visor Corazón OFF', 'info');
        }
        else if (actionName === 'reset') {
            setIsSuccessActive(false);
            setIsFailActive(false);
            setIsDestelloActive(false);
            setIsTensionActive(false);
            setIsHeartTensionActive(false);
            showMessage('Overlay de Beso reiniciado.', 'info');
        }
    };

    // --- LOGOS ---
    const uploadImage = (e, callback) => {
        const file = e.target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = (event) => {
            const img = new Image();
            img.onload = () => {
                const canvas = document.createElement('canvas');
                canvas.width = 300;
                canvas.height = Math.round((img.height * 300) / img.width);
                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                callback(canvas.toDataURL('image/png', 0.85));
            };
            img.src = event.target.result;
        };
        reader.readAsDataURL(file);
    };

    const handleLogoUpload = (e) => {
        uploadImage(e, (dataUrl) => {
            setConfig(prev => ({ ...prev, logoDataUrl: dataUrl }));
            showMessage('Logotipo de patrocinador cargado.', 'success');
        });
    };

    const removeLogo = () => {
        setConfig(prev => ({ ...prev, logoDataUrl: null }));
        if (logoInputRef.current) logoInputRef.current.value = '';
        showMessage('Logotipo removido.', 'info');
    };

    // Helper Slider con etiqueta clara y de alto contraste
    const renderSlider = (label, stateType, key, min, max, step, suffix) => {
        const targetState = stateType === 'soccer' ? config : stateType === 'dance' ? danceConfig : stateType === 'bongo' ? bongoConfig : kissConfig;
        const targetSetter = stateType === 'soccer' ? setConfig : stateType === 'dance' ? setDanceConfig : stateType === 'bongo' ? setBongoConfig : setKissConfig;
        const value = targetState[key];

        return (
            <div className="mb-4">
                <div className="d-flex justify-content-between mb-1" style={{ fontSize: '0.85rem' }}>
                    <span className="text-white fw-bold">{label}</span>
                    <span className="text-warning font-monospace fw-bold">{value} {suffix}</span>
                </div>
                <input
                    type="range"
                    className="form-range"
                    min={min}
                    max={max}
                    step={step}
                    value={value}
                    onChange={(e) => targetSetter(prev => ({ ...prev, [key]: parseFloat(e.target.value) }))}
                    style={{ height: '8px' }}
                />
            </div>
        );
    };

    // Determina el estado actual del preview activo para la capa oscura "SIN EMISIÓN"
    const getActiveConfigVisibility = () => {
        if (activePreview === 'soccer') return config.visible;
        if (activePreview === 'dance') return danceConfig.visible;
        if (activePreview === 'bongo') return bongoConfig.enabled && bongoConfig.visible;
        if (activePreview === 'kiss') return kissConfig.visible;
        if (activePreview === 'lineup') return isLineupVisible;
        if (activePreview === 'score') return isScoreVisible;
        return true;
    };

    return (
        <SecondaryBase actionToExecute={returnToDashboard}>
            <div className="row g-4 p-3 overflow-y-auto" style={{ maxHeight: 'calc(100vh - 120px)', color: '#e2e8f0' }}>
                {/* COLUMNA IZQUIERDA: ACORDEONES VERTICALES (Estilo Tombola Perrona) - Expandido a Pantalla Completa */}
                <div className="col-12 col-lg-12">
                    
                    {/* ========================================== */}
                    {/* ACORDEÓN 1: MARCADOR DE ASISTENCIA */}
                    {/* ========================================== */}
                    <div className="card shadow-sm border-0 mb-4 rounded-4 overflow-hidden" style={{ background: '#0e111a', border: '1px solid rgba(255,255,255,0.06)' }}>
                        {/* Encabezado colapsable */}
                        <div 
                            className="card-header p-3 cursor-pointer d-flex justify-content-between align-items-center text-white"
                            style={{ background: '#2e384d', borderBottom: '1px solid rgba(255,255,255,0.08)' }}
                            onClick={() => {
                                setIsSoccerMainExpanded(!isSoccerMainExpanded);
                                setIsDanceMainExpanded(false);
                                setIsBongoMainExpanded(false);
                                setIsKissMainExpanded(false);
                                if (!isSoccerMainExpanded) setActivePreview('soccer');
                            }}
                        >
                            <h5 className="m-0 fw-bold d-flex align-items-center gap-2" style={{ fontSize: '1.05rem', letterSpacing: '0.5px' }}>
                                <i className="bi bi-ticket-perforated-fill me-1"></i>
                                <span>1. Marcador de Asistencia</span>
                                <span 
                                    className="live-status-sphere" 
                                    style={{
                                        display: 'inline-block',
                                        width: '12px',
                                        height: '12px',
                                        borderRadius: '50%',
                                        backgroundColor: config.visible ? '#22c55e' : '#ef4444',
                                        boxShadow: config.visible ? '0 0 10px #22c55e' : '0 0 10px #ef4444',
                                        transition: 'all 0.3s',
                                        marginLeft: '6px'
                                    }}
                                ></span>
                            </h5>

                            <div className="d-flex align-items-center gap-3">
                                <button 
                                    className={`btn fw-bold px-3 py-1.5 text-xs rounded-2 text-white border-0 ${
                                        config.visible ? 'btn-danger' : 'btn-success'
                                    }`}
                                    style={{ 
                                        minWidth: '150px', 
                                        fontSize: '0.8rem',
                                        boxShadow: config.visible ? '0 2px 8px rgba(220, 38, 38, 0.2)' : '0 2px 8px rgba(22, 163, 74, 0.2)' 
                                    }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        toggleSoccerVisibility(!config.visible);
                                    }}
                                >
                                    {config.visible ? 'Ocultar marcador' : 'Mostrar marcador'}
                                </button>
                                <i className={`bi fs-5 ${isSoccerMainExpanded ? 'bi-chevron-up' : 'bi-chevron-down'}`} style={{ color: '#a0aec0' }}></i>
                            </div>
                        </div>

                        {/* Banner Informativo cuando está Plegado */}
                        {!isSoccerMainExpanded && (
                            <div className="card-body text-muted py-3 px-4 text-xs d-flex justify-content-between align-items-center" style={{ background: '#111827' }}>
                                <span style={{ fontSize: '0.85rem' }}>
                                    Título: <strong className="text-white">"{config.titleText}"</strong> | 
                                    Asistentes: <strong className="text-white">"{config.numberText}"</strong> | 
                                    Efecto: <strong className="text-white">"{config.animationEffect}"</strong>
                                </span>
                                <button 
                                    className="btn btn-outline-light btn-xs py-1 px-3 text-xs fw-semibold rounded-2" 
                                    style={{ fontSize: '0.75rem' }} 
                                    onClick={() => {
                                        setIsSoccerMainExpanded(true);
                                        setIsDanceMainExpanded(false);
                                        setIsBongoMainExpanded(false);
                                        setIsKissMainExpanded(false);
                                        setActivePreview('soccer');
                                    }}
                                >
                                    Ver ajustes
                                </button>
                            </div>
                        )}

                        {isSoccerMainExpanded && (
                            <div className="card-body p-4" style={{ background: '#0e111a' }}>
                                {/* Sub-textos */}
                                <div className="card bg-dark border-secondary mb-3">
                                    <div className="card-header bg-transparent border-secondary py-2 text-xs text-white fw-bold" onClick={() => setIsTextExpanded(!isTextExpanded)} style={{ cursor: 'pointer' }}>Textos del Marcador</div>
                                    {isTextExpanded && (
                                        <div className="card-body">
                                            <div className="mb-3">
                                                <label className="form-label text-xs text-muted">Título Principal</label>
                                                <input type="text" className="form-control bg-dark text-white border-secondary text-sm" value={config.titleText} onChange={(e) => setConfig(prev => ({ ...prev, titleText: e.target.value }))} />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label text-xs text-muted">Cifra de Asistentes</label>
                                                <input type="text" className="form-control bg-dark text-white border-secondary text-sm font-monospace" value={config.numberText} onChange={(e) => setConfig(prev => ({ ...prev, numberText: e.target.value }))} />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label text-xs text-muted">Mensaje de Agradecimiento</label>
                                                <input type="text" className="form-control bg-dark text-white border-secondary text-sm" value={config.thanksText} onChange={(e) => setConfig(prev => ({ ...prev, thanksText: e.target.value }))} />
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* Ajuste de Tamaño y Posición */}
                                <div className="card bg-dark border-secondary mb-3">
                                    <div className="card-header bg-transparent border-secondary py-2 text-xs text-white fw-bold" onClick={() => setIsLayoutExpanded(!isLayoutExpanded)} style={{ cursor: 'pointer' }}>Ajuste de Tamaño y Posición</div>
                                    {isLayoutExpanded && (
                                        <div className="card-body">
                                            {renderSlider('Escala de Tamaño del Marcador', 'soccer', 'scale', 0.5, 2.5, 0.05, 'x')}
                                            {renderSlider('Posición Horizontal (Eje X)', 'soccer', 'offsetX', -800, 800, 5, 'px')}
                                            {renderSlider('Posición Vertical (Eje Y)', 'soccer', 'offsetY', -500, 500, 5, 'px')}
                                        </div>
                                    )}
                                </div>

                                {/* Controles de Animación y Efecto en Vivo */}
                                <div className="card bg-dark border-secondary mb-3">
                                    <div className="card-header bg-transparent border-secondary py-2 text-xs text-white fw-bold">Configuración de Efecto y Controles</div>
                                    <div className="card-body">
                                        <div className="d-flex flex-column gap-2">
                                            <div className="d-flex gap-2">
                                                {/* Botón principal: Iniciar / Detener */}
                                                <button 
                                                    className={`btn flex-fill fw-bold py-2 text-xs rounded-2 ${config.visible ? 'btn-danger text-white' : 'btn-success text-white'}`}
                                                    style={{ fontSize: '0.78rem' }}
                                                    onClick={async () => {
                                                        if (config.visible) {
                                                            await HideSoccerOverlay();
                                                            setConfig(prev => ({ ...prev, visible: false }));
                                                            showMessage('Marcador de Asistencia ocultado.', 'warning');
                                                        } else {
                                                            // Iniciar forzando desmontado rápido
                                                            await HideSoccerOverlay();
                                                            setTimeout(async () => {
                                                                await ShowSoccerOverlay();
                                                                setConfig(prev => ({ ...prev, visible: true }));
                                                                showMessage('Marcador de Asistencia enviado al aire.', 'success');
                                                            }, 250);
                                                        }
                                                    }}
                                                >
                                                    {config.visible ? '⏹ Detener y Ocultar' : '▶ Iniciar Animación'}
                                                </button>

                                                {/* Botón de Clímax: Lanzar Destello */}
                                                <button 
                                                    className="btn btn-warning flex-fill fw-bold py-2 text-dark text-xs rounded-2"
                                                    style={{ fontSize: '0.78rem' }}
                                                    disabled={!config.visible}
                                                    onClick={async () => {
                                                        const updatedConfig = { ...config, climaxTrigger: Date.now() };
                                                        setConfig(updatedConfig);
                                                        await SetSoccerConfig(updatedConfig);
                                                        showMessage('¡Clímax detonado! Revelando cifra de asistentes...', 'success');
                                                    }}
                                                >
                                                    ⚡ Revelar Cifra / Lanzar Clímax
                                                </button>
                                            </div>

                                            {/* Botón de estado de Intro Estelar */}
                                            <button 
                                                className={`btn w-100 fw-bold py-2 text-xs rounded-2 ${config.enableAnimation !== false ? 'btn-warning text-dark' : 'btn-secondary text-white'}`}
                                                style={{ fontSize: '0.78rem' }}
                                                onClick={async () => {
                                                    const nextState = !(config.enableAnimation !== false);
                                                    const updatedConfig = { ...config, enableAnimation: nextState };
                                                    setConfig(updatedConfig);
                                                    await SetSoccerConfig(updatedConfig);
                                                    showMessage(nextState ? 'Intro de bolitas activada.' : 'Intro desactivada (aparece cifra fija al entrar).', 'info');
                                                }}
                                            >
                                                {config.enableAnimation !== false ? '✨ Intro Estelar: ACTIVO' : '✨ Intro Estelar: INACTIVO'}
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                {/* Sponsor */}
                                <div className="card bg-dark border-secondary mb-4">
                                    <div className="card-header bg-transparent border-secondary py-2 text-xs text-white fw-bold" onClick={() => setIsLogoExpanded(!isLogoExpanded)} style={{ cursor: 'pointer' }}>Logo de Patrocinador</div>
                                    {isLogoExpanded && (
                                        <div className="card-body">
                                            <input type="file" ref={logoInputRef} accept="image/*" className="form-control bg-dark text-white border-secondary text-sm mb-3" onChange={handleLogoUpload} />
                                            {config.logoDataUrl && (
                                                <>
                                                    <button className="btn btn-outline-danger btn-sm mb-3" onClick={removeLogo}>Remover Logo</button>
                                                    {renderSlider('Tamaño del Logo', 'soccer', 'logoScale', 0.5, 2.0, 0.05, 'x')}
                                                    {renderSlider('Mover Logo Horizontal (X)', 'soccer', 'logoOffsetX', -500, 500, 5, 'px')}
                                                    {renderSlider('Mover Logo Vertical (Y)', 'soccer', 'logoOffsetY', -500, 500, 5, 'px')}
                                                </>
                                            )}
                                        </div>
                                    )}
                                </div>

                                <button className="btn btn-primary w-100 fw-bold py-2.5 rounded-3 shadow text-white" onClick={saveSoccerSettings}>⚡ GUARDAR Y APLICAR CAMBIOS</button>
                            </div>
                        )}
                    </div>

                    {/* ========================================== */}
                    {/* ACORDEÓN 2: DANCE CAM (BÁILELE) */}
                    {/* ========================================== */}
                    <div className="card shadow-sm border-0 mb-4 rounded-4 overflow-hidden" style={{ background: '#0e111a', border: '1px solid rgba(255,255,255,0.06)' }}>
                        {/* Encabezado colapsable */}
                        <div 
                            className="card-header p-3 cursor-pointer d-flex justify-content-between align-items-center text-white"
                            style={{ background: '#2e384d', borderBottom: '1px solid rgba(255,255,255,0.08)' }}
                            onClick={() => {
                                setIsDanceMainExpanded(!isDanceMainExpanded);
                                setIsSoccerMainExpanded(false);
                                setIsBongoMainExpanded(false);
                                setIsKissMainExpanded(false);
                                if (!isDanceMainExpanded) setActivePreview('dance');
                            }}
                        >
                            <h5 className="m-0 fw-bold d-flex align-items-center gap-2" style={{ fontSize: '1.05rem', letterSpacing: '0.5px' }}>
                                <i className="bi bi-music-note-beamed me-1"></i>
                                <span>2. Dance Cam (Báilele)</span>
                                <span 
                                    className="live-status-sphere" 
                                    style={{
                                        display: 'inline-block',
                                        width: '12px',
                                        height: '12px',
                                        borderRadius: '50%',
                                        backgroundColor: danceConfig.visible ? '#22c55e' : '#ef4444',
                                        boxShadow: danceConfig.visible ? '0 0 10px #22c55e' : '0 0 10px #ef4444',
                                        transition: 'all 0.3s',
                                        marginLeft: '6px'
                                    }}
                                ></span>
                            </h5>

                            <div className="d-flex align-items-center gap-3">
                                <button 
                                    className={`btn fw-bold px-3 py-1.5 text-xs rounded-2 text-white border-0 ${
                                        danceConfig.visible ? 'btn-danger' : 'btn-success'
                                    }`}
                                    style={{ 
                                        minWidth: '150px', 
                                        fontSize: '0.8rem',
                                        boxShadow: danceConfig.visible ? '0 2px 8px rgba(220, 38, 38, 0.2)' : '0 2px 8px rgba(22, 163, 74, 0.2)' 
                                    }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        toggleDanceVisibility(!danceConfig.visible);
                                    }}
                                >
                                    {danceConfig.visible ? 'Ocultar dance cam' : 'Mostrar dance cam'}
                                </button>
                                <i className={`bi fs-5 ${isDanceMainExpanded ? 'bi-chevron-up' : 'bi-chevron-down'}`} style={{ color: '#a0aec0' }}></i>
                            </div>
                        </div>

                        {/* Banner Informativo cuando está Plegado */}
                        {!isDanceMainExpanded && (
                            <div className="card-body text-muted py-3 px-4 text-xs d-flex justify-content-between align-items-center" style={{ background: '#111827' }}>
                                <span style={{ fontSize: '0.85rem' }}>
                                    Título: <strong className="text-white">"{danceConfig.titleText}"</strong> | 
                                    Ritmo: <strong className="text-white">{danceConfig.bpm} BPM</strong> | 
                                    Figuras: <strong className="text-white">"{danceConfig.floatingShape}"</strong>
                                </span>
                                <button 
                                    className="btn btn-outline-light btn-xs py-1 px-3 text-xs fw-semibold rounded-2" 
                                    style={{ fontSize: '0.75rem' }} 
                                    onClick={() => {
                                        setIsDanceMainExpanded(true);
                                        setIsSoccerMainExpanded(false);
                                        setIsBongoMainExpanded(false);
                                        setIsKissMainExpanded(false);
                                        setActivePreview('dance');
                                    }}
                                >
                                    Ver ajustes
                                </button>
                            </div>
                        )}

                        {isDanceMainExpanded && (
                            <div className="card-body p-4" style={{ background: '#0e111a' }}>
                                {/* Controles Directos */}
                                <div className="card bg-dark border-secondary mb-4">
                                    <div className="card-body py-3">
                                        <div className="d-flex flex-wrap gap-2 justify-content-center">
                                            <button 
                                                className="btn btn-warning btn-sm fw-bold text-dark px-3 py-2" 
                                                onClick={triggerExplosionAction}
                                            >
                                                ✨ DETONAR DESTELLO
                                            </button>
                                            <button 
                                                className={`btn btn-sm fw-bold px-3 py-2 ${isNormalDancersActive ? 'btn-info text-white' : 'btn-outline-info'}`} 
                                                onClick={() => triggerDancersAction(false, !isNormalDancersActive)}
                                            >
                                                🕺 {isNormalDancersActive ? 'OCULTAR DANCERS' : 'MOSTRAR DANCERS'}
                                            </button>
                                            <button 
                                                className={`btn btn-sm fw-bold px-3 py-2 ${isDanceFiestaActive ? 'btn-danger text-white' : 'btn-outline-danger'}`} 
                                                onClick={() => toggleDanceFiestaAction(!isDanceFiestaActive)}
                                            >
                                                🔥 {isDanceFiestaActive ? 'APAGAR FIESTA' : 'MODO FIESTA (DROP)'}
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                {/* Sub-textos */}
                                <div className="card bg-dark border-secondary mb-3">
                                    <div className="card-header bg-transparent border-secondary py-2 text-xs text-white fw-bold" onClick={() => setIsDanceTextExpanded(!isDanceTextExpanded)} style={{ cursor: 'pointer' }}>Texto y Ritmo</div>
                                    {isDanceTextExpanded && (
                                        <div className="card-body">
                                            <div className="mb-3">
                                                <label className="form-label text-xs text-muted">Texto del Título</label>
                                                <input type="text" className="form-control bg-dark text-white border-secondary text-sm" value={danceConfig.titleText} onChange={(e) => setDanceConfig(prev => ({ ...prev, titleText: e.target.value }))} />
                                            </div>
                                            {renderSlider('Velocidad del Ritmo (BPM)', 'dance', 'bpm', 60, 200, 5, 'BPM')}
                                            {renderSlider('Zoom de los Bordes', 'dance', 'frameZoom', 80, 100, 1, '%')}
                                            {renderSlider('Escala de Tamaño General', 'dance', 'scale', 0.5, 2.0, 0.05, 'x')}
                                        </div>
                                    )}
                                </div>

                                {/* Figuras Flotantes Dance Cam */}
                                <div className="card bg-dark border-secondary mb-3">
                                    <div className="card-header bg-transparent border-secondary py-2 text-xs text-white fw-bold" onClick={() => setIsDanceShapesExpanded(!isDanceShapesExpanded)} style={{ cursor: 'pointer' }}>Figuras Flotantes</div>
                                    {isDanceShapesExpanded && (
                                        <div className="card-body">
                                            <div className="mb-3">
                                                <label className="form-label text-xs text-muted">Tipo de Figuras</label>
                                                <select className="form-select bg-dark text-white border-secondary text-sm" value={danceConfig.floatingShape} onChange={(e) => setDanceConfig(prev => ({ ...prev, floatingShape: e.target.value }))}>
                                                    <option value="notes-stars">Notas y Estrellas</option>
                                                    <option value="neon-hearts">Corazones de Neón</option>
                                                    <option value="party-dots">Círculos de Colores</option>
                                                    <option value="none">Desactivado</option>
                                                </select>
                                            </div>
                                            {renderSlider('Opacidad de Figuras', 'dance', 'shapeOpacity', 0.1, 1.0, 0.05, '')}
                                            {renderSlider('Resplandor (Glow)', 'dance', 'shapeGlow', 5, 30, 1, 'px')}
                                        </div>
                                    )}
                                </div>

                                <button className="btn btn-primary w-100 fw-bold py-2.5 rounded-3 shadow text-white" onClick={saveDanceSettings}>⚡ GUARDAR Y APLICAR CAMBIOS</button>
                            </div>
                        )}
                    </div>

                    {/* ========================================== */}
                    {/* ACORDEÓN 3: BONGO CAM (BONGOS) */}
                    {/* ========================================== */}
                    <div className="card shadow-sm border-0 mb-4 rounded-4 overflow-hidden" style={{ background: '#0e111a', border: '1px solid rgba(255,255,255,0.06)' }}>
                        {/* Encabezado colapsable */}
                        <div 
                            className="card-header p-3 cursor-pointer d-flex justify-content-between align-items-center text-white"
                            style={{ background: '#2e384d', borderBottom: '1px solid rgba(255,255,255,0.08)' }}
                            onClick={() => {
                                setIsBongoMainExpanded(!isBongoMainExpanded);
                                setIsSoccerMainExpanded(false);
                                setIsDanceMainExpanded(false);
                                setIsKissMainExpanded(false);
                                if (!isBongoMainExpanded) setActivePreview('bongo');
                            }}
                        >
                            <h5 className="m-0 fw-bold d-flex align-items-center gap-2" style={{ fontSize: '1.05rem', letterSpacing: '0.5px' }}>
                                <i className="bi bi-dribbble me-1"></i>
                                <span>3. Bongo Cam (Bongos)</span>
                                <span 
                                    className="live-status-sphere" 
                                    style={{
                                        display: 'inline-block',
                                        width: '12px',
                                        height: '12px',
                                        borderRadius: '50%',
                                        backgroundColor: !bongoConfig.enabled ? '#64748b' : bongoConfig.visible ? '#22c55e' : '#ef4444',
                                        boxShadow: !bongoConfig.enabled ? '0 0 5px #64748b' : bongoConfig.visible ? '0 0 10px #22c55e' : '0 0 10px #ef4444',
                                        transition: 'all 0.3s',
                                        marginLeft: '6px'
                                    }}
                                ></span>
                            </h5>

                            <div className="d-flex align-items-center gap-3">
                                {bongoConfig.enabled && (
                                    <button 
                                        className={`btn fw-bold px-3 py-1.5 text-xs rounded-2 text-white border-0 ${
                                            bongoConfig.visible ? 'btn-danger' : 'btn-success'
                                        }`}
                                        style={{ 
                                            minWidth: '150px', 
                                            fontSize: '0.8rem',
                                            boxShadow: bongoConfig.visible ? '0 2px 8px rgba(220, 38, 38, 0.2)' : '0 2px 8px rgba(22, 163, 74, 0.2)' 
                                        }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            toggleBongoVisibility(!bongoConfig.visible);
                                        }}
                                    >
                                        {bongoConfig.visible ? 'Ocultar bongo cam' : 'Mostrar bongo cam'}
                                    </button>
                                )}
                                <i className={`bi fs-5 ${isBongoMainExpanded ? 'bi-chevron-up' : 'bi-chevron-down'}`} style={{ color: '#a0aec0' }}></i>
                            </div>
                        </div>

                        {/* Banner Informativo cuando está Plegado */}
                        {!isBongoMainExpanded && (
                            <div className="card-body text-muted py-3 px-4 text-xs d-flex justify-content-between align-items-center" style={{ background: '#111827' }}>
                                <span style={{ fontSize: '0.85rem' }}>
                                    Habilitado: <strong className="text-white">{bongoConfig.enabled ? 'Sí' : 'No'}</strong> | 
                                    Diseño: <strong className="text-white">"{bongoConfig.bongoSkin}"</strong> | 
                                    Ritmo: <strong className="text-white">{bongoConfig.bpm} BPM</strong>
                                </span>
                                <button 
                                    className="btn btn-outline-light btn-xs py-1 px-3 text-xs fw-semibold rounded-2" 
                                    style={{ fontSize: '0.75rem' }} 
                                    onClick={() => {
                                        setIsBongoMainExpanded(true);
                                        setIsSoccerMainExpanded(false);
                                        setIsDanceMainExpanded(false);
                                        setIsKissMainExpanded(false);
                                        setActivePreview('bongo');
                                    }}
                                >
                                    Ver ajustes
                                </button>
                            </div>
                        )}

                        {isBongoMainExpanded && (
                            <div className="card-body p-4" style={{ background: '#0e111a' }}>
                                {/* Habilitación general */}
                                <div className="d-flex align-items-center justify-content-between bg-dark p-3 rounded border border-secondary mb-4">
                                    <div>
                                        <span className="text-sm fw-bold text-white d-block">Módulo Habilitado (Ahorro de energía)</span>
                                        <span className="text-muted text-xs">Apaga totalmente micrófonos, eventos y bucles si no se utiliza.</span>
                                    </div>
                                    <div className="form-check form-switch">
                                        <input className="form-check-input" type="checkbox" checked={bongoConfig.enabled} onChange={(e) => setBongoConfig(prev => ({ ...prev, enabled: e.target.checked }))} style={{ width: '40px', height: '20px' }} />
                                    </div>
                                </div>

                                {bongoConfig.enabled && (
                                    <>
                                        <div className="card bg-dark border-secondary mb-3">
                                            <div className="card-header bg-transparent border-secondary py-2 text-xs text-white fw-bold" onClick={() => setIsBongoStyleExpanded(!isBongoStyleExpanded)} style={{ cursor: 'pointer' }}>Skins e Instrumento</div>
                                            {isBongoStyleExpanded && (
                                                <div className="card-body">
                                                    <label className="form-label text-xs text-muted">Diseño de los Bongos</label>
                                                    <select className="form-select bg-dark text-white border-secondary text-sm mb-3" value={bongoConfig.bongoSkin} onChange={(e) => setBongoConfig(prev => ({ ...prev, bongoSkin: e.target.value }))}>
                                                        <option value="classic-wood">Madera Clásica</option>
                                                        <option value="neon-cyberpunk">Neon Cyberpunk</option>
                                                        <option value="soccer-special">Fútbol Especial (Balones)</option>
                                                    </select>
                                                    {renderSlider('Escala de Tamaño de Bongos', 'bongo', 'scale', 0.5, 2.0, 0.05, 'x')}
                                                    {renderSlider('Posición Vertical (Eje Y)', 'bongo', 'offsetY', -300, 300, 5, 'px')}
                                                    {renderSlider('Ritmo Animaciones (BPM)', 'bongo', 'bpm', 60, 200, 5, 'BPM')}
                                                </div>
                                            )}
                                        </div>

                                        {/* Figuras Flotantes Bongo Cam */}
                                        <div className="card bg-dark border-secondary mb-3">
                                            <div className="card-header bg-transparent border-secondary py-2 text-xs text-white fw-bold" onClick={() => setIsBongoLayoutExpanded(!isBongoLayoutExpanded)} style={{ cursor: 'pointer' }}>Figuras Flotantes (Maracas, Luciérnagas)</div>
                                            {isBongoLayoutExpanded && (
                                                <div className="card-body">
                                                    <div className="mb-3">
                                                        <label className="form-label text-xs text-muted">Tipo de Figura Flotante</label>
                                                        <select className="form-select bg-dark text-white border-secondary text-sm" value={bongoConfig.floatingShape} onChange={(e) => setBongoConfig(prev => ({ ...prev, floatingShape: e.target.value }))}>
                                                            <option value="fireflies">Luciérnagas</option>
                                                            <option value="maracas">Maracas Divertidas</option>
                                                            <option value="stars">Estrellas Brillantes</option>
                                                            <option value="none">Desactivado</option>
                                                        </select>
                                                    </div>
                                                    {renderSlider('Opacidad de las Figuras', 'bongo', 'shapeOpacity', 0.1, 1.0, 0.05, '')}
                                                    {renderSlider('Resplandor de las Figuras', 'bongo', 'shapeGlow', 5, 30, 1, 'px')}
                                                </div>
                                            )}
                                        </div>

                                        <button className="btn btn-primary w-100 fw-bold py-2.5 rounded-3 shadow text-white" onClick={saveBongoSettings}>⚡ GUARDAR Y APLICAR CAMBIOS</button>
                                    </>
                                )}
                            </div>
                        )}
                    </div>

                    {/* ========================================== */}
                    {/* ACORDEÓN 4: KISS CAM (CÁMARA DEL BESO) */}
                    {/* ========================================== */}
                    <div className="card shadow-sm border-0 mb-4 rounded-4 overflow-hidden" style={{ background: '#0e111a', border: '1px solid rgba(255,255,255,0.06)' }}>
                        {/* Encabezado colapsable */}
                        <div 
                            className="card-header p-3 cursor-pointer d-flex justify-content-between align-items-center text-white"
                            style={{ background: '#2e384d', borderBottom: '1px solid rgba(255,255,255,0.08)' }}
                            onClick={() => {
                                setIsKissMainExpanded(!isKissMainExpanded);
                                setIsSoccerMainExpanded(false);
                                setIsDanceMainExpanded(false);
                                setIsBongoMainExpanded(false);
                                if (!isKissMainExpanded) setActivePreview('kiss');
                            }}
                        >
                            <h5 className="m-0 fw-bold d-flex align-items-center gap-2" style={{ fontSize: '1.05rem', letterSpacing: '0.5px' }}>
                                <i className="bi bi-heart-fill me-1"></i>
                                <span>4. Kiss Cam (Cámara del Beso)</span>
                                <span 
                                    className="live-status-sphere" 
                                    style={{
                                        display: 'inline-block',
                                        width: '12px',
                                        height: '12px',
                                        borderRadius: '50%',
                                        backgroundColor: kissConfig.visible ? '#22c55e' : '#ef4444',
                                        boxShadow: kissConfig.visible ? '0 0 10px #22c55e' : '0 0 10px #ef4444',
                                        transition: 'all 0.3s',
                                        marginLeft: '6px'
                                    }}
                                ></span>
                            </h5>

                            <div className="d-flex align-items-center gap-3">
                                <button 
                                    className={`btn fw-bold px-3 py-1.5 text-xs rounded-2 text-white border-0 ${
                                        kissConfig.visible ? 'btn-danger' : 'btn-success'
                                    }`}
                                    style={{ 
                                        minWidth: '150px', 
                                        fontSize: '0.8rem',
                                        boxShadow: kissConfig.visible ? '0 2px 8px rgba(220, 38, 38, 0.2)' : '0 2px 8px rgba(22, 163, 74, 0.2)' 
                                    }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        toggleKissVisibility(!kissConfig.visible);
                                    }}
                                >
                                    {kissConfig.visible ? 'Ocultar kiss cam' : 'Mostrar kiss cam'}
                                </button>
                                <i className={`bi fs-5 ${isKissMainExpanded ? 'bi-chevron-up' : 'bi-chevron-down'}`} style={{ color: '#a0aec0' }}></i>
                            </div>
                        </div>

                        {/* Banner Informativo cuando está Plegado */}
                        {!isKissMainExpanded && (
                            <div className="card-body text-muted py-3 px-4 text-xs d-flex justify-content-between align-items-center" style={{ background: '#111827' }}>
                                <span style={{ fontSize: '0.85rem' }}>
                                    Título: <strong className="text-white">"{kissConfig.titleText}"</strong> | 
                                    Marco: <strong className="text-white">"{kissConfig.frameStyle}"</strong> | 
                                    Filtro: <strong className="text-white">"{kissConfig.screenFilter}"</strong>
                                </span>
                                <button 
                                    className="btn btn-outline-light btn-xs py-1 px-3 text-xs fw-semibold rounded-2" 
                                    style={{ fontSize: '0.75rem' }} 
                                    onClick={() => {
                                        setIsKissMainExpanded(true);
                                        setIsSoccerMainExpanded(false);
                                        setIsDanceMainExpanded(false);
                                        setIsBongoMainExpanded(false);
                                        setActivePreview('kiss');
                                    }}
                                >
                                    Ver ajustes
                                </button>
                            </div>
                        )}

                        {isKissMainExpanded && (
                            <div className="card-body p-4" style={{ background: '#0e111a' }}>
                                {/* Control interactivo */}
                                <div className="card bg-dark border-secondary mb-4">
                                    <div className="card-body py-3">
                                        <div className="d-flex flex-wrap gap-2 justify-content-center">
                                            <button 
                                                className={`btn btn-sm fw-bold px-3 py-2 ${isDestelloActive ? 'btn-warning text-dark' : 'btn-outline-warning'}`} 
                                                onClick={() => triggerKissLiveAction('destello', !isDestelloActive)}
                                            >
                                                ✨ {isDestelloActive ? 'OCULTAR DESTELLO' : 'MOSTRAR DESTELLO'}
                                            </button>
                                            <button 
                                                className={`btn btn-sm fw-bold px-3 py-2 ${isSuccessActive ? 'btn-danger text-white' : 'btn-outline-danger'}`} 
                                                onClick={() => triggerKissLiveAction('success', !isSuccessActive)}
                                            >
                                                ❤️ {isSuccessActive ? 'OCULTAR BESO' : 'MOSTRAR BESO'}
                                            </button>
                                            <button 
                                                className={`btn btn-sm fw-bold px-3 py-2 ${isFailActive ? 'btn-dark text-white border-secondary' : 'btn-outline-secondary'}`} 
                                                onClick={() => triggerKissLiveAction('fail', !isFailActive)}
                                            >
                                                👎 {isFailActive ? 'OCULTAR FRACASO' : 'MOSTRAR FRACASO'}
                                            </button>
                                            <button 
                                                className={`btn btn-sm fw-bold px-3 py-2 ${isHeartTensionActive ? 'btn-info text-white' : 'btn-outline-info'}`} 
                                                onClick={() => triggerKissLiveAction('hearttension', !isHeartTensionActive)}
                                            >
                                                💓 {isHeartTensionActive ? 'OCULTAR VISOR' : 'VISOR CORAZÓN'}
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                {/* Textos */}
                                <div className="card bg-dark border-secondary mb-3">
                                    <div className="card-header bg-transparent border-secondary py-2 text-xs text-white fw-bold" onClick={() => setIsKissTextExpanded(!isKissTextExpanded)} style={{ cursor: 'pointer' }}>Textos y Títulos</div>
                                    {isKissTextExpanded && (
                                        <div className="card-body">
                                            <div className="mb-3">
                                                <label className="form-label text-xs text-muted">Texto del Título de Éxito</label>
                                                <input type="text" className="form-control bg-dark text-white border-secondary text-sm" value={kissConfig.titleText} onChange={(e) => setKissConfig(prev => ({ ...prev, titleText: e.target.value }))} />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label text-xs text-muted">Texto de Abucheo (Beso fallido)</label>
                                                <input type="text" className="form-control bg-dark text-white border-secondary text-sm" value={kissConfig.failText} onChange={(e) => setKissConfig(prev => ({ ...prev, failText: e.target.value }))} />
                                            </div>
                                            {renderSlider('Tamaño del Título', 'kiss', 'titleSize', 2.0, 6.0, 0.1, 'rem')}
                                        </div>
                                    )}
                                </div>

                                {/* Estilos del marco */}
                                <div className="card bg-dark border-secondary mb-3">
                                    <div className="card-header bg-transparent border-secondary py-2 text-xs text-white fw-bold" onClick={() => setIsKissStyleExpanded(!isKissStyleExpanded)} style={{ cursor: 'pointer' }}>Diseño del Marco y Filtro</div>
                                    {isKissStyleExpanded && (
                                        <div className="card-body">
                                            <div className="mb-3">
                                                <label className="form-label text-xs text-muted">Estilo del Marco</label>
                                                <select className="form-select bg-dark text-white border-secondary text-sm" value={kissConfig.frameStyle} onChange={(e) => setKissConfig(prev => ({ ...prev, frameStyle: e.target.value }))}>
                                                    <option value="classic-red">Clásico Rojo</option>
                                                    <option value="double-gold">Doble Dorado</option>
                                                    <option value="cyber-glow">Cibernético Resplandor</option>
                                                    <option value="none">Sin Marco</option>
                                                </select>
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label text-xs text-muted">Filtro de Cámara</label>
                                                <select className="form-select bg-dark text-white border-secondary text-sm" value={kissConfig.screenFilter} onChange={(e) => setKissConfig(prev => ({ ...prev, screenFilter: e.target.value }))}>
                                                    <option value="none">Normal (Sin Filtro)</option>
                                                    <option value="sepia">Sepia Vintage</option>
                                                    <option value="pink-romantic">Rosa Amor</option>
                                                    <option value="grayscale">Blanco y Negro</option>
                                                </select>
                                            </div>
                                            {renderSlider('Zoom del Visor de Corazón', 'kiss', 'frameZoom', 80, 98, 1, '%')}
                                            {renderSlider('Escala de Tamaño General', 'kiss', 'scale', 0.5, 2.0, 0.05, 'x')}
                                            {renderSlider('Desplazamiento Vertical Y', 'kiss', 'offsetY', -300, 300, 5, 'px')}
                                        </div>
                                    )}
                                </div>

                                {/* Velocidades de Animación */}
                                <div className="card bg-dark border-secondary mb-3">
                                    <div className="card-header bg-transparent border-secondary py-2 text-xs text-white fw-bold" onClick={() => setIsKissSpeedExpanded(!isKissSpeedExpanded)} style={{ cursor: 'pointer' }}>Velocidad de Animaciones (Duración)</div>
                                    {isKissSpeedExpanded && (
                                        <div className="card-body">
                                            {renderSlider('Duración Beso (Éxito)', 'kiss', 'successSpeed', 0.5, 4.0, 0.1, 's')}
                                            {renderSlider('Duración Fracaso (Boo)', 'kiss', 'failSpeed', 0.5, 4.0, 0.1, 's')}
                                            {renderSlider('Duración Destello', 'kiss', 'destelloSpeed', 0.5, 4.0, 0.1, 's')}
                                        </div>
                                    )}
                                </div>

                                {/* Figuras Flotantes Kiss Cam */}
                                <div className="card bg-dark border-secondary mb-3">
                                    <div className="card-header bg-transparent border-secondary py-2 text-xs text-white fw-bold" onClick={() => setIsKissShapesExpanded(!isKissShapesExpanded)} style={{ cursor: 'pointer' }}>Figuras Flotantes (Corazones, Labios)</div>
                                    {isKissShapesExpanded && (
                                        <div className="card-body">
                                            <div className="mb-3">
                                                <label className="form-label text-xs text-muted">Tipo de Figura</label>
                                                <select className="form-select bg-dark text-white border-secondary text-sm" value={kissConfig.floatingShape} onChange={(e) => setKissConfig(prev => ({ ...prev, floatingShape: e.target.value }))}>
                                                    <option value="hearts">Corazones Clásicos</option>
                                                    <option value="lips">Labios (Besos)</option>
                                                    <option value="broken-hearts">Corazones Rotos</option>
                                                </select>
                                            </div>
                                            {renderSlider('Opacidad Figuras', 'kiss', 'shapeOpacity', 0.1, 1.0, 0.05, '')}
                                            {renderSlider('Resplandor Figuras', 'kiss', 'shapeGlow', 5, 30, 1, 'px')}
                                        </div>
                                    )}
                                </div>
                                <button className="btn btn-primary w-100 fw-bold py-2.5 rounded-3 shadow text-white" onClick={saveKissSettings}>⚡ GUARDAR Y APLICAR CAMBIOS</button>
                            </div>
                        )}
                    </div>

                    {/* ========================================== */}
                    {/* ACORDEÓN 5: ALINEACIÓN (LINEUP) */}
                    {/* ========================================== */}
                    <div className="card shadow-sm border-0 mb-4 rounded-4 overflow-hidden" style={{ background: '#0e111a', border: '1px solid rgba(255,255,255,0.06)' }}>
                        {/* Encabezado colapsable */}
                        <div 
                            className="card-header p-3 cursor-pointer d-flex justify-content-between align-items-center text-white"
                            style={{ background: '#2e384d', borderBottom: '1px solid rgba(255,255,255,0.08)' }}
                            onClick={() => {
                                setIsLineupMainExpanded(!isLineupMainExpanded);
                                setIsSoccerMainExpanded(false);
                                setIsDanceMainExpanded(false);
                                setIsBongoMainExpanded(false);
                                setIsKissMainExpanded(false);
                                setIsScoreMainExpanded(false);
                                if (!isLineupMainExpanded) setActivePreview('lineup');
                            }}
                        >
                            <h5 className="m-0 fw-bold d-flex align-items-center gap-2" style={{ fontSize: '1.05rem', letterSpacing: '0.5px' }}>
                                <i className="bi bi-diagram-3 me-1"></i>
                                <span>5. Alineación</span>
                                <span 
                                    className="live-status-sphere" 
                                    style={{
                                        display: 'inline-block',
                                        width: '12px',
                                        height: '12px',
                                        borderRadius: '50%',
                                        backgroundColor: isLineupVisible ? '#22c55e' : '#ef4444',
                                        boxShadow: isLineupVisible ? '0 0 10px #22c55e' : '0 0 10px #ef4444',
                                        transition: 'all 0.3s',
                                        marginLeft: '6px'
                                    }}
                                ></span>
                            </h5>
                            <div className="d-flex align-items-center gap-3">
                                <button 
                                    className={`btn fw-bold px-3 py-1.5 text-xs rounded-2 text-white border-0 ${
                                        isLineupVisible ? 'btn-danger' : 'btn-success'
                                    }`}
                                    style={{ 
                                        minWidth: '150px', 
                                        fontSize: '0.8rem',
                                        boxShadow: isLineupVisible ? '0 2px 8px rgba(220, 38, 38, 0.2)' : '0 2px 8px rgba(22, 163, 74, 0.2)' 
                                    }}
                                    onClick={async (e) => {
                                        e.stopPropagation();
                                        const nextState = !isLineupVisible;
                                        await TriggerPresentation(nextState ? 'show_board' : 'hide_board');
                                        setIsLineupVisible(nextState);
                                        showMessage(nextState ? 'Pizarra de alineación mostrada.' : 'Pizarra de alineación ocultada.', 'info');
                                    }}
                                >
                                    {isLineupVisible ? 'Ocultar alineación' : 'Mostrar alineación'}
                                </button>
                                <i className={`bi fs-5 ${isLineupMainExpanded ? 'bi-chevron-up' : 'bi-chevron-down'}`} style={{ color: '#a0aec0' }}></i>
                            </div>
                        </div>

                        {isLineupMainExpanded && (
                            <div className="card-body p-4" style={{ background: '#0e111a' }}>
                                <LineupAdmin getOutOfTheDynamic={getOutOfTheDynamic} isEmbedded={true} />
                            </div>
                        )}
                    </div>

                    {/* ========================================== */}
                    {/* ACORDEÓN 6: MARCADOR (SCORE) */}
                    {/* ========================================== */}
                    <div className="card shadow-sm border-0 mb-4 rounded-4 overflow-hidden" style={{ background: '#0e111a', border: '1px solid rgba(255,255,255,0.06)' }}>
                        {/* Encabezado colapsable */}
                        <div 
                            className="card-header p-3 cursor-pointer d-flex justify-content-between align-items-center text-white"
                            style={{ background: '#2e384d', borderBottom: '1px solid rgba(255,255,255,0.08)' }}
                            onClick={() => {
                                setIsScoreMainExpanded(!isScoreMainExpanded);
                                setIsSoccerMainExpanded(false);
                                setIsDanceMainExpanded(false);
                                setIsBongoMainExpanded(false);
                                setIsKissMainExpanded(false);
                                setIsLineupMainExpanded(false);
                                if (!isScoreMainExpanded) setActivePreview('score');
                            }}
                        >
                            <h5 className="m-0 fw-bold d-flex align-items-center gap-2" style={{ fontSize: '1.05rem', letterSpacing: '0.5px' }}>
                                <i className="bi bi-tv me-1"></i>
                                <span>6. Marcador del Partido</span>
                                <span 
                                    className="live-status-sphere" 
                                    style={{
                                        display: 'inline-block',
                                        width: '12px',
                                        height: '12px',
                                        borderRadius: '50%',
                                        backgroundColor: isScoreVisible ? '#22c55e' : '#ef4444',
                                        boxShadow: isScoreVisible ? '0 0 10px #22c55e' : '0 0 10px #ef4444',
                                        transition: 'all 0.3s',
                                        marginLeft: '6px'
                                    }}
                                ></span>
                            </h5>
                            <div className="d-flex align-items-center gap-3">
                                <button 
                                    className={`btn fw-bold px-3 py-1.5 text-xs rounded-2 text-white border-0 ${
                                        isScoreVisible ? 'btn-danger' : 'btn-success'
                                    }`}
                                    style={{ 
                                        minWidth: '150px', 
                                        fontSize: '0.8rem',
                                        boxShadow: isScoreVisible ? '0 2px 8px rgba(220, 38, 38, 0.2)' : '0 2px 8px rgba(22, 163, 74, 0.2)' 
                                    }}
                                    onClick={async (e) => {
                                        e.stopPropagation();
                                        const nextState = !isScoreVisible;
                                        await UpdateScoreStyle({ isVisible: nextState });
                                        setIsScoreVisible(nextState);
                                        showMessage(nextState ? 'Marcador mostrado en pantalla.' : 'Marcador ocultado de pantalla.', 'info');
                                    }}
                                >
                                    {isScoreVisible ? 'Ocultar marcador' : 'Mostrar marcador'}
                                </button>
                                <i className={`bi fs-5 ${isScoreMainExpanded ? 'bi-chevron-up' : 'bi-chevron-down'}`} style={{ color: '#a0aec0' }}></i>
                            </div>
                        </div>

                        {isScoreMainExpanded && (
                            <div className="card-body p-4" style={{ background: '#0e111a' }}>
                                <ScoreAdmin getOutOfTheDynamic={getOutOfTheDynamic} isEmbedded={true} />
                            </div>
                        )}
                    </div>

                </div>

                {/* COLUMNA DERECHA: PREVISUALIZACIÓN COMENTADA TEMPORALMENTE
                <div className="col-12 col-lg-5">
                    <div className="sticky-top" style={{ top: '24px' }}>
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <span className="text-xs text-muted fw-bold text-uppercase">VISTA PREVIA SIMULADA DE OBS</span>
                            <div className="d-flex gap-1 flex-wrap">
                                <button className={`btn btn-xs ${activePreview === 'soccer' ? 'btn-primary text-white' : 'btn-dark'}`} onClick={() => setActivePreview('soccer')}>Asist</button>
                                <button className={`btn btn-xs ${activePreview === 'dance' ? 'btn-primary text-white' : 'btn-dark'}`} onClick={() => setActivePreview('dance')}>Baile</button>
                                <button className={`btn btn-xs ${activePreview === 'bongo' ? 'btn-primary text-white' : 'btn-dark'}`} onClick={() => setActivePreview('bongo')}>Bongos</button>
                                <button className={`btn btn-xs ${activePreview === 'kiss' ? 'btn-primary text-white' : 'btn-dark'}`} onClick={() => setActivePreview('kiss')}>Beso</button>
                                <button className={`btn btn-xs ${activePreview === 'lineup' ? 'btn-primary text-white' : 'btn-dark'}`} onClick={() => setActivePreview('lineup')}>Alineac</button>
                                <button className={`btn btn-xs ${activePreview === 'score' ? 'btn-primary text-white' : 'btn-dark'}`} onClick={() => setActivePreview('score')}>Marcador</button>
                            </div>
                        </div>
                        <div 
                            className="preview-obs-canvas border border-secondary rounded shadow relative overflow-hidden" 
                            style={{ 
                                width: '100%', 
                                aspectRatio: '16/9', 
                                background: 'radial-gradient(circle, #1a1b24 0%, #06070a 100%)',
                                position: 'relative'
                            }}
                        >
                            {!getActiveConfigVisibility() && (
                                <div className="absolute top-0 start-0 w-100 h-100 bg-black bg-opacity-75 d-flex flex-column justify-content-center align-items-center z-3" style={{ pointerEvents: 'none' }}>
                                    <i className="bi bi-eye-slash-fill fs-2 text-danger mb-2"></i>
                                    <span className="text-white fw-bold text-sm">SIN EMISIÓN</span>
                                    <span className="text-muted text-xs mt-1">El overlay está oculto en OBS. Haz clic en "MOSTRAR".</span>
                                </div>
                            )}

                            {activePreview === 'soccer' ? (
                                <SoccerOverlay config={config} />
                            ) : activePreview === 'dance' ? (
                                <DanceOverlay config={danceConfig} activeDancers={['normal/3.gif', 'normal/4.gif']} />
                            ) : activePreview === 'bongo' ? (
                                <BongoOverlay config={bongoConfig} leftHitActive={false} rightHitActive={false} intensityLevel={0} />
                            ) : activePreview === 'kiss' ? (
                                <KissOverlay config={kissConfig} tensionActive={false} heartTensionActive={false} successActive={false} failActive={false} />
                            ) : activePreview === 'lineup' ? (
                                <LineupOverlay data={null} />
                            ) : (
                                <ScoreOverlay data={null} />
                            )}
                        </div>
                    </div>
                </div>
                */}

            </div>
        </SecondaryBase>
    );
};

export { Soccer };
export default Soccer;
